export const surface = "white/black.1600";
export const surfaceBright = "white/black.1400";
export const surfaceContainer = "white/black.1100";
export const surfaceContainerVariant = "navy.100/black.800";
export const outline = "navy.200/black.1000";
export const outlineVariant = "navy.300/black.400";
export const onSurface = "navy.1100/grey.300";
export const onSurfaceVariant = "navy.600/grey.700";
export const onSurfaceContainerVariant = "grey.500/grey.1300";
export const disabled = "navy_alpha.8/grey_alpha.20";
export const onSurfaceDisabled = "navy_alpha.40/grey_alpha.45";
export const primary = "purple.1100/purple.600";
export const onPrimary = "white/black.1600";
export const primaryContainer = "purple.200/purple.1600";
export const onPrimaryContainer = "purple.1100/purple.200";
export const secondary = "violet.900/violet.400";
export const onSecondary = "violet.100/black.1600";
export const secondaryContainer = "violet.100/violet.1400";
export const onSecondaryContainer = "violet.1500/violet.100";
export const onSecondaryContainerVariant = "violet.800/violet.500";
export const tertiary = "blue.900/blue.700";
export const onTertiary = "white/blue.100";
export const outlineTertiary = "blue.1000/blue.800";
export const tertiaryContainer = "blue.200/blue.1400";
export const onTertiaryContainer = "violet.1600/blue.100";
export const onTertiaryContainerVariant = "blue.1000/blue.300";
export const success = "green.1000/green.600";
export const onSuccess = "green.100/black.1200";
export const successContainer = "green.200/green.1200";
export const onSuccessContainer = "green.1300/green.200";
export const error = "red.800/red.500";
export const onError = "white/black.1600";
export const errorContainer = "red.100/red.1400";
export const onErrorContainer = "red.1100/red.200";
export const warning = "yellow.800/yellow.600";
export const onWarning = "yellow.1500/black.1600";
export const warningContainer = "yellow.200/yellow.1600";
export const onWarningContainer = "yellow.1400/yellow.500";
export const neutral = "navy.1100/grey.300";
export const onNeutral = "white/black.1600";
export const connect = "purple.800/purple.500";
export const onConnect = "white/black.1600";
export const keyExchange = "violet.700/violet.500";
export const onKeyExchange = "white/black.1600";
export const seasonLowest = "green.200/green.300";
export const onSeasonLowest = "black.1600/black.1600";
export const seasonMedium = "green.600/green.700";
export const onSeasonMedium = "black.1600/black.1600";
export const seasonHigh = "green.1000/green.1100";
export const onSeasonHigh = "white/white";
export const seasonHighest = "green.1300/green.1400";
export const onSeasonHighest = "white/white";
export const business = "violet.1400/violet.1400";
export const businessVariant = "violet.1100/violet.1100";
export const onBusiness = "white/white";
export const onBusinessVariant = "lime.500/lime.300";
export const businessContainer = "lime.300/lime.200";
export const onBusinessContainer = "violet.1600/violet.1300";
export const hover = "black_alpha.4/white_alpha.15";
export const focus = "black_alpha.8/white_alpha.20";
export const press = "black_alpha.8/white_alpha.20";
export const drag = "black_alpha.16/white_alpha.20";
export const scrim = "black_alpha.26/black_alpha.26";
export const surfaceFixed = "white/grey.100";
export const onSurfaceFixed = "navy.1100/navy.1100";
export const inverseSurface = "navy.1100/grey.100";
export const inverseOnSurface = "grey.100/black.1600";
export const marketingContainer = "lime.100/lime.1500";
export const onMarketingContainer = "lime.1500/lime.200";
export default {
  "surface": "white/black.1600",
  "surfaceBright": "white/black.1400",
  "surfaceContainer": "white/black.1100",
  "surfaceContainerVariant": "navy.100/black.800",
  "outline": "navy.200/black.1000",
  "outlineVariant": "navy.300/black.400",
  "onSurface": "navy.1100/grey.300",
  "onSurfaceVariant": "navy.600/grey.700",
  "onSurfaceContainerVariant": "grey.500/grey.1300",
  "disabled": "navy_alpha.8/grey_alpha.20",
  "onSurfaceDisabled": "navy_alpha.40/grey_alpha.45",
  "primary": "purple.1100/purple.600",
  "onPrimary": "white/black.1600",
  "primaryContainer": "purple.200/purple.1600",
  "onPrimaryContainer": "purple.1100/purple.200",
  "secondary": "violet.900/violet.400",
  "onSecondary": "violet.100/black.1600",
  "secondaryContainer": "violet.100/violet.1400",
  "onSecondaryContainer": "violet.1500/violet.100",
  "onSecondaryContainerVariant": "violet.800/violet.500",
  "tertiary": "blue.900/blue.700",
  "onTertiary": "white/blue.100",
  "outlineTertiary": "blue.1000/blue.800",
  "tertiaryContainer": "blue.200/blue.1400",
  "onTertiaryContainer": "violet.1600/blue.100",
  "onTertiaryContainerVariant": "blue.1000/blue.300",
  "success": "green.1000/green.600",
  "onSuccess": "green.100/black.1200",
  "successContainer": "green.200/green.1200",
  "onSuccessContainer": "green.1300/green.200",
  "error": "red.800/red.500",
  "onError": "white/black.1600",
  "errorContainer": "red.100/red.1400",
  "onErrorContainer": "red.1100/red.200",
  "warning": "yellow.800/yellow.600",
  "onWarning": "yellow.1500/black.1600",
  "warningContainer": "yellow.200/yellow.1600",
  "onWarningContainer": "yellow.1400/yellow.500",
  "neutral": "navy.1100/grey.300",
  "onNeutral": "white/black.1600",
  "connect": "purple.800/purple.500",
  "onConnect": "white/black.1600",
  "keyExchange": "violet.700/violet.500",
  "onKeyExchange": "white/black.1600",
  "seasonLowest": "green.200/green.300",
  "onSeasonLowest": "black.1600/black.1600",
  "seasonMedium": "green.600/green.700",
  "onSeasonMedium": "black.1600/black.1600",
  "seasonHigh": "green.1000/green.1100",
  "onSeasonHigh": "white/white",
  "seasonHighest": "green.1300/green.1400",
  "onSeasonHighest": "white/white",
  "business": "violet.1400/violet.1400",
  "businessVariant": "violet.1100/violet.1100",
  "onBusiness": "white/white",
  "onBusinessVariant": "lime.500/lime.300",
  "businessContainer": "lime.300/lime.200",
  "onBusinessContainer": "violet.1600/violet.1300",
  "hover": "black_alpha.4/white_alpha.15",
  "focus": "black_alpha.8/white_alpha.20",
  "press": "black_alpha.8/white_alpha.20",
  "drag": "black_alpha.16/white_alpha.20",
  "scrim": "black_alpha.26/black_alpha.26",
  "surfaceFixed": "white/grey.100",
  "onSurfaceFixed": "navy.1100/navy.1100",
  "inverseSurface": "navy.1100/grey.100",
  "inverseOnSurface": "grey.100/black.1600",
  "marketingContainer": "lime.100/lime.1500",
  "onMarketingContainer": "lime.1500/lime.200"
}
;